module.exports = __webpack_public_path__ + "img/jugems-cloud-junkyard.fd6532a3.jpg";